import React, { useLayoutEffect } from "react";
import { motion } from "framer-motion";

import RevampHeroProfessionals from "./RevampHeroProfessionals";
import RevampProfessionalsProfiles from "./RevampProfessionalsProfiles";
import RevampProfessionalsOnboarding from "./RevampProfessionalsOnboarding";
import RevampProfessionalsPro from "./RevampProfessionalsPro";

import "./revamp.css";

const fadeUp = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
    transition: {
      duration: 0.5,
      ease: "easeInOut",
    },
  },
};

function RevampHomeProfessionals() {
  useLayoutEffect(() => {
    const container = document.querySelector(".revamp-pro-page");
    if (!container) return undefined;

    const headingSelectors = [
      "h1",
      "h2",
      ".revamp-hero-heading",
      ".revamp-profiles-heading",
      ".revamp-onboarding-heading",
      ".revamp-pro-heading",
    ].join(", ");

    const headings = Array.from(container.querySelectorAll(headingSelectors));
    if (!headings.length) return undefined;

    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReducedMotion) {
      headings.forEach((heading) => heading.classList.add("revamp-heading-in-view"));
      return undefined;
    }

    const originals = new Map();
    const animateClass = "revamp-heading-letter";
    const splitTextNodes = (node, indexRef) => {
      const childNodes = Array.from(node.childNodes);
      childNodes.forEach((child) => {
        if (child.nodeType === Node.TEXT_NODE) {
          const text = child.textContent || "";
          if (!text.trim()) return;

          const fragment = document.createDocumentFragment();
          Array.from(text).forEach((char) => {
            if (char === " ") {
              fragment.appendChild(document.createTextNode(char));
              return;
            }
            const span = document.createElement("span");
            span.className = animateClass;
            span.style.setProperty("--revamp-letter-delay", `${indexRef.value * 18}ms`);
            span.textContent = char;
            fragment.appendChild(span);
            indexRef.value += 1;
          });
          child.replaceWith(fragment);
          return;
        }

        if (child.nodeType === Node.ELEMENT_NODE) {
          splitTextNodes(child, indexRef);
        }
      });
    };

    headings.forEach((heading) => {
      originals.set(heading, heading.innerHTML);
      heading.classList.add("revamp-heading-animate");
      splitTextNodes(heading, { value: 0 });
    });

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("revamp-heading-in-view");
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -4%" }
    );

    headings.forEach((heading) => observer.observe(heading));

    return () => {
      observer.disconnect();
      headings.forEach((heading) => {
        const original = originals.get(heading);
        if (original) heading.innerHTML = original;
      });
    };
  }, []);

  return (
    <div className="revamp-page revamp-page-with-footer revamp-pro-page">
      <main className="revamp-home-main revamp-pro-main">

        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          <RevampHeroProfessionals />
        </motion.div>

        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          <RevampProfessionalsProfiles />
        </motion.div>

        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          <RevampProfessionalsOnboarding />
        </motion.div>

        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          <RevampProfessionalsPro />
        </motion.div>

      </main>

    </div>
  );
}

export default RevampHomeProfessionals;